import { events } from '@/constants';
import { on, emit, hydrate } from '@/neon/events';

const classes = {
  visible: 'visible',
};

const headerOverlay = node => {
  if (!node) return;
  const overlay = node;

  const overlayShowListener = on(events.headerOverlay.show, () =>
    _showOverlay()
  );
  const overlayHideListener = on(events.headerOverlay.hide, () =>
    _hideOverlay()
  );

  const _showOverlay = () => {
    hydrate({ headerOverlayOpen: true });
    overlay.classList.add(classes.visible);
  };

  const _hideOverlay = () => {
    hydrate({ headerOverlayOpen: false });
    emit(events.headerOverlay.hiding);
    overlay.classList.remove(classes.visible);
  };

  const unload = () => {
    overlayShowListener();
    overlayHideListener();
  };

  return { unload };
};

export default headerOverlay;
